<template>
  <div class="gx-chk custom-el-wrapper">
    <gx-loading :show="loading" />
<!--    <div class="gx-chk__tabs" v-if="tab !== 0">
      <button class="gx-chk__tab" :class="{ 'gx-chk__tab&#45;&#45;on': tab === 1 }" @click="switchMainTab(1)">图片检测 </button>
      <button class="gx-chk__tab" :class="{ 'gx-chk__tab&#45;&#45;on': tab === 2 }" @click="switchMainTab(2)">星人鉴图 </button>
    </div>-->
    <!-- ========== 标题检测 ========== -->
    <template v-if="tab === 0">
      <div class="gx-chk__tabs">
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': kwLogSub === 0 }"  @click="switchKwLogSub(0)" >关键词检测 </button>
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': kwLogSub === 1 }" @click="switchKwLogSub(1)" >检测记录</button>
      </div>

      <!-- 标题检测-关键词检测 -->
      <div v-if="kwLogSub === 0" class="gx-chk__kw">
        <div class="gx-chk__filter custom-form-wrap">
          <el-form inline size="mini">
            <el-form-item label="关键词">
              <el-input v-model="kwSearch.word" placeholder="请输入" ></el-input>
            </el-form-item>
            <el-form-item label="检测词分类">
              <el-select v-model="kwSearch.lexicon_type" multiple collapse-tags clearable placeholder="全部" @change="handleKwSearch">
                <el-option v-for="item in dictionaryWordsList" :key="item.id" :value="item.id" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
              <div class="gx-chk__fitem gx-chk__fitem--btns">
                <button type="button" class="gx-chk__btn gx-chk__btn--lg gx-chk__btn--orange-all" @click="handleKwSearch">查询</button>
                <button type="button" class="gx-chk__btn gx-chk__btn--lg" @click="refreshKw">重置</button>
              </div>
            </el-form-item>
          </el-form>

          <div class="gx-chk__fitem gx-chk__fitem--right">
            <button class="gx-chk__btn gx-chk__btn--lg gx-chk__btn--danger" :disabled="!kwSelected.length" @click="kwBatchDelete">批量删除</button>
            <button class="gx-chk__btn gx-chk__btn--lg" @click="handleKwAdd">批量新增</button>
            <button class="gx-chk__btn gx-chk__btn--lg" @click="handleKwCheck">提交检测</button>
            <button class="gx-chk__btn gx-chk__btn--lg gx-chk__btn--blue" @click="switchKwLogSub(1)">检测记录</button>
            <button class="gx-chk__btn gx-chk__btn--lg" @click="handleDictionAdd">检测词分类管理</button>
          </div>

        </div>
        <div class="gx-chk__table">
          <table>
            <thead>
            <tr>
              <th style="width: 36px">
                  <span class="gx-chk__check" :class="{ 'gx-chk__check--on': kwAllChecked }" @click="toggleKwAll">
                    <svg v-if="kwAllChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </th>
              <th>序号</th>
              <th>关键词</th>
              <th>分类</th>
              <th>检测词分类</th>
              <th>创建时间</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in kwList" :key="row.id">
              <td>
                  <span class="gx-chk__check" :class="{ 'gx-chk__check--on': kwSelected.includes(row.id) }" @click="toggleKwSel(row)">
                    <svg v-if="kwSelected.includes(row.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </td>
              <td class="gx-chk__mono">{{ idx + 1 }}</td>
              <td style="font-weight: 600;">{{ row.word }}</td>
              <td>
                <span class="gx-chk__tag" :class="row.merchant_id === 0 ? 'gx-chk__tag--sys' : 'gx-chk__tag--self'">{{ row.merchant_id === 0 ? '系统' : '自配' }}</span>
              </td>
              <td>
                <span>{{ lexiconName(row.lexicon_type) }}</span>
              </td>
              <td class="gx-chk__mono gx-chk__dim">{{ row.created_at }}</td>
            </tr>
            <tr v-if="!kwList.length">
              <td :colspan="6" class="gx-chk__empty">暂无关键词</td>
            </tr>
            </tbody>
          </table>
          <div class="gx-chk__pager gx-chk__pager--kw" v-if="kwPage.total > 0">
            <!-- 左:总条数 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--left">
              <span class="gx-chk__pager-total">共 <span style="color: rgb(26, 26, 46);font-weight: 600;">{{ kwPage.total }}</span> 条</span>
              <el-select :value="kwPage.limit" class="gx-chk__pager-size" @change="onKwPageSizeChange" size="mini">
                <el-option v-for="s in kwPageSizeOptions" :key="s" :value="s" :label="`${s}条/页`" />
              </el-select>
            </div>
            <!-- 中:页码按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--center custom-page-wrap">
              <el-pagination
                :total="kwPage.total"
                :page-size="kwPage.limit"
                :current-page="kwPage.page"
                layout="prev, pager, next"
                small
                @current-change="getKwList"
              />
            </div>
            <!-- 右:每页大小 + 跳转 + 按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--right">
              <span class="gx-chk__pager-jump">
                <span>前往</span>
                <input v-model.number="kwJumpInput" class="gx-chk__pager-input" @keyup.enter="onKwJump" />
                <span>页</span>
              </span>
              <button class="gx-chk__log__cancel" @click="onKwJump">确定</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 标题检测-检测记录 -->
      <div v-else class="gx-chk__log">
        <div class="gx-chk__filter">
          <div class="search-wrap custom-form-wrap">
            <el-form inline size="mini" :model="logSearch" ref="searchForm">
                <el-form-item label="状态">
                  <el-select v-model="logSearch.status" clearable placeholder="全部" class="w200"  @change="handleLogSearch">
                      <el-option v-for="g in logStatusList" :key="g.status" :label="g.label" :value="g.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="商品分组">
                  <el-select v-model="logSearch.group_id" clearable placeholder="全部" class="w200"  @change="handleLogSearch">
                      <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                  </el-select>
                </el-form-item>
            </el-form>
          </div>
          <div class="gx-chk__fitem gx-chk__fitem--btns">
            <button class="gx-chk__btn gx-chk__btn--lg" @click="handleLogRefresh"> 刷新 </button>
          </div>
        </div>
        <div class="gx-chk__table">
          <table>
            <thead>
            <tr>
              <th>批次</th>
              <th>商品渠道</th>
              <th>商品分组</th>
              <th>检测分类</th>
              <th>检测方法</th>
              <th>正常</th>
              <th>异常</th>
              <th>状态</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in logList" :key="row.id">
              <td class="gx-chk__mono" style="color: rgb(22, 119, 255);">{{ row.task_no }}</td>
              <td>{{ logChanneList[row.channel] }}</td>
              <td>
                <span v-if="getGroupNameText(row.group_id, row.child_group_id)" class="gx-chk__group" :title="getGroupNameText(row.group_id, row.child_group_id)">{{ getGroupNameText(row.group_id, row.child_group_id) }}</span>
                <span v-else class="gx-chk__dim">-</span>
              </td>
              <td>{{ getLexiconTypeText(row.lexicon_type) }}</td>
              <td>
                <span class="gx-chk__tag" :class="row.detection_method==1 ? 'gx-chk__tag--sys' : 'gx-chk__tag--self'">{{ logMethodList[row.detection_method] ? logMethodList[row.detection_method].label : '' }}</span>
              </td>
              <td class="gx-chk__mono" style="color: rgb(82, 196, 26);">{{ row.normal_count || 0 }}</td>
              <td class="gx-chk__mono" style="color: rgb(200, 68, 60);">{{ row.abnormal_count || 0 }}</td>
              <td><span class="gx-chk__status" :style="logStatusStyle(row.status)">{{ logStatusList[row.status] ? logStatusList[row.status].label : '' }}</span></td>
              <td class="gx-chk__mono gx-chk__dim">{{ row.created_at }}</td>
              <td>
                <div class="gx-chk__ops">
                  <button class="gx-chk__btn gx-chk__btn--sm gx-chk__btn--blue" @click="openLogDetail(row)">详情</button>
                  <button v-if="[1, 2].includes(row.status)" class="gx-chk__btn gx-chk__btn--sm gx-chk__btn--danger" @click="handleStopLog(row)">终止检测</button>
                </div>
              </td>
            </tr>
            <tr v-if="!logList.length">
              <td :colspan="9" class="gx-chk__empty">暂无检测记录</td>
            </tr>
            </tbody>
          </table>
          <div class="gx-chk__pager">
            <Pagination :total="logPage.total" :page.sync="logPage.page" :limit.sync="logPage.limit" @pagination="getLogList(logPage.page)" layout="total, sizes, prev, pager, next, jumper" v-if="logPage.total > 0"/>
          </div>
        </div>
      </div>
    </template>

    <!-- ========== AI图片检测 ========== -->
    <template v-else-if="tab === 1">
      <div class="gx-chk__tabs">
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': subTab === 'list' }" @click="switchSubTab('list')" >检测列表 </button>
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': subTab === 'task' }" @click="switchSubTab('task')" >任务列表 </button>
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': subTab === 'alien'&&alienType===9 }" @click="switchSubTab('alien',9)">星人AI检测 </button>
        <button class="gx-chk__tab" :class="{ 'gx-chk__tab--on': subTab === 'alien'&&alienType===8 }" @click="switchSubTab('alien',8)">星人虚假检测 </button>
      </div>

      <!-- 图片检测-检测列表 -->
      <div v-if="subTab === 'list'">
        <div class="gx-chk__filter gx-chk__filter--white">
          <div>
            <div class="search-wrap custom-form-wrap">
              <el-form inline size="mini" :model="imgSearch" ref="searchForm" label-position="top" >
                  <el-form-item label="分组">
                    <el-select v-model="imgSearch.group_id" clearable placeholder="全部" class="w200"  @change="handleImgGroupSearch">
                        <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="子分组">
                    <el-select v-model="imgSearch.child_group_id" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                        <el-option v-for="g in imgChildGroupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="sku替换状态">
                    <el-select v-model="imgSearch.sku_status" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                        <el-option v-for="(v, k) in skuStatus" :key="k" :label="v.label" :value="k"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="检测状态">
                    <el-select v-model="imgSearch.image_check_status" clearable placeholder="全部" class="w140"  @change="handleImgSearch">
                        <el-option v-for="(v, k) in checkStatus" :key="k" :label="v.label" :value="k"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="AI检测状态">
                    <el-select v-model="imgSearch.ai_image_check_status" clearable placeholder="全部" class="w40"  @change="handleImgSearch">
                        <el-option v-for="(v, k) in checkStatus" :key="k" :label="v.label" :value="k"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="鉴图状态">
                    <el-select v-model="imgSearch.appraisal_status" clearable placeholder="全部" class="w140"  @change="handleImgSearch">
                        <el-option v-for="(v, k) in appraisalStatus" :key="k" :label="v.label" :value="k"></el-option>
                    </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <!-- <div class="gx-chk__frow"> -->
            <!-- <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">分组</label>
              <select v-model="imgSearch.group_id" class="gx-chk__select" @change="handleImgGroupSearch">
                <option value="">全部</option>
                <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
              </select>
            </div>
            <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">子分组</label>
              <select v-model="imgSearch.child_group_id" class="gx-chk__select" @change="handleImgSearch">
                <option value="">全部</option>
                <option v-for="g in imgChildGroupList" :key="g.id" :value="g.id">{{ g.name }}</option>
              </select>
            </div> -->
            <!-- <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">sku替换状态</label>
              <select v-model="imgSearch.sku_status" class="gx-chk__select" @change="handleImgSearch">
                <option value="">全部</option>
                <option v-for="(v, k) in skuStatus" :key="k" :value="k">{{ v.label }}</option>
              </select>
            </div> -->
            <!-- <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">检测状态</label>
              <select v-model="imgSearch.image_check_status" class="gx-chk__select" @change="handleImgSearch">
                <option value="">全部</option>
                <option v-for="(v, k) in checkStatus" :key="k" :value="k">{{ v.label }}</option>
              </select>
            </div>
            <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">AI检测状态</label>
              <select v-model="imgSearch.ai_image_check_status" class="gx-chk__select" @change="handleImgSearch">
                <option value="">全部</option>
                <option v-for="(v, k) in checkStatus" :key="k" :value="k">{{ v.label }}</option>
              </select>
            </div> -->
            <!-- <div class="gx-chk__fitem gx-chk__fitem--col">
              <label class="gx-chk__flabel">鉴图状态</label>
              <select v-model="imgSearch.appraisal_status" class="gx-chk__select" @change="handleImgSearch">
                <option value="">全部</option>
                <option v-for="(v, k) in appraisalStatus" :key="k" :value="v.value">{{ v.label }}</option>
              </select>
            </div> -->
             <div class="gx-chk__btns">
              <button class="gx-chk__btn" @click="handleBatch('ai')">AI检测</button>
              <button class="gx-chk__btn gx-chk__btn--danger" @click="handleBatch('false')">虚假检测</button>
            </div>
          </div>

          <div class="gx-chk__frow gx-chk__frow--bottom">
            <span class="gx-chk__selected">已选 <b class="gx-chk__gold">{{ checkedList.length }}</b> 件商品</span>
          </div>
        </div>
        <div class="gx-chk__table">
          <table>
            <thead>
            <tr>
              <th style="width: 36px">
                  <span class="gx-chk__check" :class="{ 'gx-chk__check--on': imgAllChecked }" @click="toggleImgAll">
                    <svg v-if="imgAllChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </th>
              <th>序号</th>
              <th>商品信息</th>
              <th>分组|子分组</th>
              <th>sku替换</th>
              <th>检测结果</th>
              <th>AI检测结果</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in imgList" :key="row.item_id">
              <td>
                  <span class="gx-chk__check" :class="{ 'gx-chk__check--on': checkedList.includes(row.item_id) }" @click="toggleImgSel(row)">
                    <svg v-if="checkedList.includes(row.item_id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </td>
              <td class="gx-chk__mono">{{ idx + 1 }}</td>
              <td>
                <div class="gx-chk__goods">
                  <span class="gx-chk__thumb" @click="previewSingle(row.main_image)"><img v-if="row.main_image" :src="row.main_image" alt="" /><span v-else>🛍️</span></span>
                  <div class="gx-chk__goods-body">
                    <div class="gx-chk__goods-title" :title="row.title">{{ row.title }}</div>
                    <div class="gx-chk__mono gx-chk__dim">{{ row.source_product_id }}</div>
                  </div>
                </div>
              </td>
              <td>
                <span v-if="formatGroupName(row)" class="gx-chk__group" :title="formatGroupName(row)">{{ formatGroupName(row) }}</span>
                <span v-else class="gx-chk__dim">-</span>
              </td>
              <td><span class="gx-chk__tag" :class="skuTagCls(row.sku_status)">{{ skuStatus[row.sku_status] ? skuStatus[row.sku_status].label : '' }}</span></td>
              <td><span class="gx-chk__tag" :class="checkTagCls(row.image_check_status)">{{ checkStatus[row.image_check_status] ? checkStatus[row.image_check_status].label : '' }}</span></td>
              <td><span class="gx-chk__tag" :class="checkTagCls(row.ai_image_check_status)">{{ checkStatus[row.ai_image_check_status] ? checkStatus[row.ai_image_check_status].label : '' }}</span></td>
              <td><button class="gx-chk__op gx-chk__op--edit" @click="handleDetail(row)">详情</button></td>
            </tr>
            <tr v-if="!imgList.length">
              <td :colspan="8" class="gx-chk__empty">暂无商品</td>
            </tr>
            </tbody>
          </table>

          <div class="gx-chk__pager gx-chk__pager--kw" v-if="imgPage.total > 0">
            <!-- 左:总条数 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--left">
              <span class="gx-chk__pager-total">共 <span style="color: rgb(26, 26, 46);font-weight: 600;">{{ imgPage.total }}</span> 条</span>
              <page-size-select :value="imgPage.limit" :options="imgPageSizeOptions" @change="onImgPageSizeChange" />
            </div>
            <!-- 中:页码按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--center custom-page-wrap">
              <el-pagination
                :total="imgPage.total"
                :page-size="imgPage.limit"
                :current-page="imgPage.page"
                layout="prev, pager, next"
                @current-change="getImgList"
                small
              />
            </div>
            <!-- 右:每页大小 + 跳转 + 按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--right">
              <span class="gx-chk__pager-jump">
                <span>前往</span>
                <input v-model.number="tuJumpInput" class="gx-chk__pager-input" @keyup.enter="onTuJump" />
                <span>页</span>
              </span>
              <button class="gx-chk__log__cancel" @click="onTuJump">确定</button>
            </div>
        </div>
        </div>

      </div>

      <!-- 图片检测-任务列表 -->
      <div v-else-if="subTab==='task'">
        <div class="gx-chk__filter">
            <div class="search-wrap custom-form-wrap">
              <el-form inline size="mini" :model="imgTaskSearch" ref="searchForm">
                  <el-form-item label="状态">
                    <el-select v-model="imgTaskSearch.status" clearable placeholder="全部" class="w200"  @change="handleImgSearch">
                        <el-option v-for="(label, v) in filterConfig.status_filter" :key="v" :label="label" :value="v"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
            </div>
          <div class="gx-chk__fitem gx-chk__fitem--btns">
            <button class="gx-chk__btn gx-chk__btn--orange-all" @click="handleImgSearch">查询</button>
            <button class="gx-chk__btn" @click="refreshImg">重置</button>
          </div>
        </div>
        <div class="gx-chk__table">
          <table>
            <thead>
            <tr>
              <th>任务编号</th>
              <th>商品分组</th>
              <th>渠道</th>
              <th>检测范围</th>
              <th>检测类型</th>
              <th>商品数量</th>
              <th>进度</th>
              <th>状态</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in imgTaskList" :key="row.id">
              <td>
                <div class="gx-chk__mono">{{ row.task_no }}</div>
                <div class="gx-chk__power">扣除算力：{{ row.total_power_num }}</div>
              </td>
              <td>
                <span v-if="getGroupNameText(row.group_id, row.child_group_id)" class="gx-chk__group" :title="getGroupNameText(row.group_id, row.child_group_id)">{{ getGroupNameText(row.group_id, row.child_group_id) }}</span>
                <span v-else class="gx-chk__dim">-</span>
              </td>
              <td>{{ filterConfig.channel_filter ? filterConfig.channel_filter[row.channel] : '' }}</td>
              <td>
                <div>{{ filterConfig.detection_scope_filter ? filterConfig.detection_scope_filter[row.detection_scope] : '' }}</div>
                <div v-if="row.detection_scope == 2" class="gx-chk__dim">
                  <div>主图：{{ filterConfig.main_filter ? filterConfig.main_filter[row.include_main] : '' }}</div>
                  <div>详情图：{{ filterConfig.detail_filter ? filterConfig.detail_filter[row.include_detail] : '' }}</div>
                  <div>Sku图：{{ filterConfig.sku_filter ? filterConfig.sku_filter[row.include_sku] : '' }}</div>
                </div>
              </td>
              <td>{{ filterConfig.detection_type_filter ? filterConfig.detection_type_filter[row.detection_type] : '' }}</td>
              <td class="gx-chk__mono">{{ row.product_num }}</td>
              <td class="gx-chk__counts">
                <div>待检测：{{ row.waiting_num || 0 }}</div>
                <div>检测中：{{ row.processing_num || 0 }}</div>
                <div>已完成：{{ row.complete_num || 0 }}</div>
              </td>
              <td>
                <div class="gx-chk__status-cell">
                  <span class="gx-chk__status" :style="imgTaskStatusStyle(row.status)">{{ filterConfig.status_filter ? filterConfig.status_filter[row.status] : row.status }}</span>
                  <div v-if="row.remark" class="gx-chk__err" :title="row.remark">{{ row.remark }}</div>
                </div>
              </td>
              <td class="gx-chk__mono gx-chk__dim">{{ row.created_at }}</td>
              <td>
                <div class="gx-chk__ops">
                  <button v-if="row.status == 1 || row.status == 2 || row.status == 8" class="gx-chk__op gx-chk__op--danger" @click="handleStopTask(row)">终止</button>
                  <button v-if="row.status == 1 || row.status == 2" class="gx-chk__op" @click="handlePauseTask(row)">暂停</button>
                  <button v-if="row.status == 8" class="gx-chk__op gx-chk__op--recover" @click="handleStartTask(row)">启动</button>
                </div>
              </td>
            </tr>
            <tr v-if="!imgTaskList.length">
              <td :colspan="10" class="gx-chk__empty">暂无任务</td>
            </tr>
            </tbody>
          </table>
          <div class="gx-chk__pager gx-chk__pager--kw" v-if="imgPage.total > 0">
            <!-- 左:总条数 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--left">
              <span class="gx-chk__pager-total">共 <span style="color: rgb(26, 26, 46);font-weight: 600;">{{ imgPage.total }}</span> 条</span>
              <page-size-select :value="imgPage.limit" :options="imgPageSizeOptions" @change="onImgPageSizeChangeTask" />
            </div>
            <!-- 中:页码按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--center custom-page-wrap">
              <el-pagination
                :total="imgPage.total"
                :page-size="imgPage.limit"
                :current-page="imgPage.page"
                layout="prev, pager, next"
                small
                @current-change="getImgTaskList"
              />
            </div>
            <!-- 右:每页大小 + 跳转 + 按钮组 -->
            <div class="gx-chk__pager-col gx-chk__pager-col--right">
              <span class="gx-chk__pager-jump">
                <span>前往</span>
                <input v-model.number="tuTaskJumpInput" class="gx-chk__pager-input" @keyup.enter="onTuTaskJump" />
                <span>页</span>
              </span>
              <button class="gx-chk__log__cancel" @click="onTuTaskJump">确定</button>
            </div>
        </div>
        </div>
      </div>

      <!-- ========== 星人鉴图 ========== -->
      <new-alien-check-page :alien-type="alienType" :show-back="false" v-else />
    </template>


    <!-- 弹窗：新增关键词 -->
    <div v-if="kwAddShow" class="gx-chk__modal" @click.self="kwAddShow = false">
      <div class="gx-chk__modal-box gx-chk__modal-box--add">
        <div class="gx-chk__modal-head">
          <div class="gx-chk__modal-head-left">
            <div class="gx-chk__line"></div>
            <span class="gx-chk__modal-title">新增关键词</span>
          </div>
          <button class="gx-chk__modal-close" @click="kwAddShow = false">✕</button>
        </div>
        <div class="gx-chk__modal-body gx-chk__add-kw">
          <div class="gx-chk__add-kw__row">
            <div class="gx-chk__field">
              <label class="gx-chk__label">检测词分类 <i class="gx-chk__req">*</i></label>
              <select v-model="kwAddInfo.lexicon_type" class="gx-chk__select gx-chk__select--full">
                <option value="">请选择检测词分类</option>
                <option v-for="d in dictionaryWordsList" :key="d.id" :value="d.id" v-if="d.merchant_id !== 0 || ismanager">{{ d.dictionary_name }}<span v-if="d.merchant_id === 0">（系统）</span><span v-else>（自配）</span></option>
              </select>
            </div>
          </div>
          <div class="gx-chk__add-kw__kw">
            <div class="gx-chk__field">
              <label class="gx-chk__label">关键词 <i class="gx-chk__req">*</i></label>
              <textarea v-model="kwAddInfo.keywords" class="gx-chk__textarea" rows="8" placeholder="填写格式示例：
测试
测试2
测试3">
            </textarea>
            </div>
          </div>
        </div>
        <div class="gx-chk__modal-foot">
          <button class="gx-chk__btn" @click="kwAddShow = false">取消</button>
          <button class="gx-chk__btn gx-chk__btn--lg gx-chk__btn--orange-all" :disabled="kwAddLoading" @click="submitKwAdd">
            {{ kwAddLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：检测关键词 -->
    <div v-if="kwCheckShow" class="gx-chk__modal" @click.self="kwCheckShow = false">
      <div class="gx-chk__modal-box">
        <div class="gx-chk__modal-head">
          <div class="gx-chk__modal-head-left">
            <div class="gx-chk__line"></div>
            <span class="gx-chk__modal-title">检测关键词</span>
          </div>
          <button class="gx-chk__modal-close" @click="kwCheckShow = false">✕</button>
        </div>
        <div class="gx-chk__modal-body">
          <div class="gx-chk__field">
            <label class="gx-chk__label">检测词分类</label>
            <multi-select v-model="kwCheckInfo.lexicon_type" :options="dictionaryWordsList" placeholder="全部" />
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">商品渠道 <i class="gx-chk__req">*</i></label>
            <select v-model="kwCheckInfo.channel" class="gx-chk__select gx-chk__select--full">
              <option v-for="(v, k) in channeList" :key="k" :value="k">{{ v.label }}</option>
            </select>
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">商品分组</label>
            <multi-select v-model="kwCheckInfo.group_id" :options="groupList" placeholder="全部" @input="changeCheckGroupIds" />
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">商品子分组</label>
            <multi-select v-model="kwCheckInfo.child_group_id" :options="checkChildGroupList" placeholder="全部" />
          </div>
          <div class="gx-chk__field">
          <label class="gx-chk__label">检测方式 <i class="gx-chk__req">*</i></label>
          <div class="gx-chk__radio-group">
            <!-- 循环 methodList 渲染单选按钮 -->
            <label
              class="gx-chk__radio-item"
              :class="{checked: kwCheckInfo.detection_method === k}"
              v-for="(item, k) in methodList"
              :key="k"
            >
              <input type="radio" v-model="kwCheckInfo.detection_method" :value="k" />
              <span>{{ item.label }}</span>
            </label>
          </div>
        </div>
        </div>
        <div class="gx-chk__modal-foot">
          <button class="gx-chk__btn" @click="kwCheckShow = false">取消</button>
          <button class="gx-chk__btn gx-chk__btn--lg gx-chk__btn--orange-all" :disabled="kwCheckLoading" @click="submitKwCheck">
            {{ kwCheckLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：图片详情 -->
    <div v-if="detailShow" class="gx-modal" @click.self="detailShow = false">
      <div class="gx-modal-box gx-chk__modal-box--lg">
        <div class="gx-modal-head">
          <span class="gx-modal-title">详情</span>
          <button class="gx-modal-close" @click="detailShow = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-chk__detail-head">
            <span class="gx-chk__thumb gx-chk__thumb--nobor" @click="previewSingle(detailInfo.main_image)">
              <img v-if="detailInfo.main_image" :src="detailInfo.main_image" alt="" />
              <span v-else>🛍️</span>
            </span>
            <div class="gx-chk__goods-body">
              <div class="gx-chk__detail-goods-title">{{ detailInfo.title }}</div>
              <div class="text-gray" style="font-size: 11px">商品ID：{{ detailInfo.source_product_id }}</div>
            </div>
          </div>
          <div class="gx-chk__detail-list">
            <div v-for="(item,index) in imgDetailList" :key="index" style="margin-bottom: 14px;">
              <div class="gx-chk__detail-title"><span class="gx-chk__detail-bar"></span>{{ item.label }}</div>
              <div  class="gx-chk__detail-imgs">
                <template v-for="(img, i) in item.imgs">
                  <el-image v-if="img" :src="img" alt="" :key="i" class="gx-chk__thumb gx-chk__thumb--lg" :preview-src-list="item.imgs"></el-image>
                </template>
              </div>
            </div>
            <div v-if="!imgDetailList.length" class="gx-chk__empty">暂无图片</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：批量检测 -->
    <div v-if="batchShow" class="gx-chk__modal" @click.self="batchShow = false">
      <div class="gx-chk__modal-box">
        <div class="gx-chk__modal-head">
          <span class="gx-chk__modal-title">{{ batchType === 'ai' ? 'AI检测' : '虚假检测' }}</span>
          <button class="gx-chk__modal-close" @click="batchShow = false">✕</button>
        </div>
        <div class="gx-chk__modal-body">
          <div class="gx-chk__field custom-el-wrapper">
            <label class="gx-chk__label">检测范围 <i class="gx-chk__req">*</i></label>
            <el-checkbox v-model="imgInclude.include_main" :false-label="0" :true-label="1">检测主图</el-checkbox>
            <el-checkbox v-model="imgInclude.include_detail" :false-label="0" :true-label="1">检测详情图</el-checkbox>
            <el-checkbox v-model="imgInclude.include_sku" :false-label="0" :true-label="1">检测Sku图</el-checkbox>
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">商品分组</label>
            <multi-select v-model="batchInfo.group_ids" :options="groupList" placeholder="全部" @input="changeBatchGroupIds" />
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">商品子分组</label>
            <multi-select v-model="batchInfo.child_group_id" :options="batchChildGroupList" placeholder="全部" />
          </div>
          <div class="gx-chk__field">
            <label class="gx-chk__label">检测方式 <i class="gx-chk__req">*</i></label>
            <select v-model="batchInfo.detection_method" class="gx-chk__select gx-chk__select--full">
              <option v-for="c in checkWays" :key="c.value" :value="c.value">{{ c.label }}</option>
            </select>
            <p v-if="batchInfo.detection_method === 9" class="gx-chk__dim">已选 <b class="gx-chk__gold">{{ checkedList.length }}</b> 条数据</p>
          </div>
          <div class="gx-chk__power-box">
            <div class="gx-chk__dim">预计消耗算力(稍微会有出入，以实际扣点为准)：{{ powerNumTotal }}算力</div>
            <div class="gx-chk__power-row">
              <span>当前账号剩余算力：{{ userInfo.power_num }}</span>
              <button class="gx-chk__op" :disabled="userLoading" @click="getUserInfo(true)">刷新</button>
              <button class="gx-chk__op gx-chk__op--recover" @click="toRecharge">去充值</button>
            </div>
          </div>
        </div>
        <div class="gx-chk__modal-foot">
          <button class="gx-chk__btn" @click="batchShow = false">取消</button>
          <button class="gx-chk__btn gx-chk__btn--warn" :disabled="batchLoading" @click="submitBatchCheck">
            {{ batchLoading ? '检测中...' : '开始检测' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：检测记录详情 -->
    <el-dialog :title="`详情 - ${ logDetailInfo.task_no }`" :visible.sync="logDetailShow" class="custom-el-wrapper" width="80%">
      <div class="gx-chk__modal-field custom-form-wrap">
        <el-form inline size="mini">
          <el-form-item>
            <el-select v-model="logDetailGroupIds" clearable multiple collapse-tags placeholder="全部分组" @change="handleLogDetailSearch" class="w_220">
              <el-option v-for="group in logSearchGroup" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="logDetailLexiconType" clearable placeholder="检测词分类" class="w_220" multiple collapse-tags @change="handleLogDetailSearch">
              <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="logDetailWord" placeholder="违规词" size="small" clearable class="w140" @blur="handleLogDetailSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="logDetailStatus" clearable multiple collapse-tags placeholder="全部状态" @change="handleLogDetailSearch" class="w140">
              <el-option v-for="item in logDetailStatusOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="logOperStatus" clearable multiple collapse-tags placeholder="全部" @change="handleLogDetailSearch" class="w140">
              <el-option v-for="item in logOperStatusOptions" :key="item.id" :label="item.name"  :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btns">
            <button type="button" class="btn" @click="handleLogDetailRefresh">刷新</button>
          </el-form-item>
        </el-form>
      </div>
      <div class="gx-chk__actionrow">
        <button class="gx-chk__btn gx-chk__btn--recover" :disabled="!logDetailSelected.length" @click="handleLogBatch(4)">批量正常</button>
        <button class="gx-chk__btn" :disabled="!logDetailSelected.length" @click="handleLogBatch(2)">批量过滤</button>
        <button class="gx-chk__btn gx-chk__btn--danger" :disabled="!logDetailSelected.length" @click="handleLogBatch(3)">批量下架</button>
        <span class="gx-chk__counts gx-chk__counts--stat">未检测 {{ logCountData.untreated_count || 0 }} / 正常 {{ logCountData.normal_count || 0 }} / 异常 {{ logCountData.abnormal_count || 0 }}</span>
      </div>
      <div class="gx-chk__table gx-table">
        <table>
          <thead>
          <tr>
            <th style="width: 36px">
              <span class="gx-chk__check" :class="{ 'gx-chk__check--on': logDetailSelectedAll}" @click="toggleLogDetailSelAll()">
                <svg v-if="logDetailSelectedAll" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </th>
            <th>商品分组</th>
            <th>标题</th>
            <th>预计过滤后标题</th>
            <th>结果反馈</th>
            <th>状态</th>
            <th>操作状态</th>
            <th>创建时间</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in logDetailList" :key="row.id">
            <td>
                  <span class="gx-chk__check" :class="{ 'gx-chk__check--on': logDetailSelected.includes(row),'gx-chk__check--disabled':!(row.status == 3 && row.oper_status == 1) }" @click="toggleLogDetailSel(row)">
                    <svg v-if="logDetailSelected.includes(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
            </td>
            <td>
              <span v-if="logFormatGroupName(row)" class="gx-chk__group" :title="logFormatGroupName(row)">{{ logFormatGroupName(row) }}</span>
              <span v-else class="gx-chk__dim">-</span>
            </td>
            <td class="gx-chk__txt" :title="row.title">{{ row.title }}</td>
            <td class="gx-chk__txt" :title="row.replace_title">{{ row.replace_title }}</td>
            <td class="gx-chk__txt" :title="row.result_feedback">{{ row.result_feedback }}</td>
            <td><span class="gx-chk__tag" :class="logDetailStatusCls(row.status)">{{ logDetailStatusText(row.status) }}</span></td>
            <td>{{ logOperStatusList[row.oper_status] }}</td>
            <td class="gx-chk__mono gx-chk__dim">{{ row.created_at }}</td>
          </tr>
          <tr v-if="!logDetailList.length">
            <td :colspan="8" class="gx-chk__empty">暂无明细</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-top: 12px">
        <Pagination :total="logDetailPage.total" :page.sync="logDetailPage.page" :limit.sync="logDetailPage.limit" :pageSizes="[10,20,50,100,200,500,1000]"
                    @pagination="getLogDetailList(logDetailPage.page)"  layout="total, sizes, prev, pager, next, jumper" v-if="logDetailPage.total > 0"/>
      </div>
    </el-dialog>

    <!-- 弹窗：单图预览 -->
    <div v-if="singleImgShow" class="gx-chk__modal" @click.self="singleImgShow = false">
      <div class="gx-chk__modal-box gx-chk__modal-box--lg">
        <div class="gx-chk__modal-head">
          <span class="gx-chk__modal-title">图片预览</span>
          <button class="gx-chk__modal-close" @click="singleImgShow = false">✕</button>
        </div>
        <div class="gx-chk__modal-body">
          <img :src="singleImgUrl" class="gx-chk__single-img" alt="" />
        </div>
      </div>
    </div>

    <!-- 检测词分类管理（新版 UI） -->
    <dictionary-manage @dataChange="initKwData" :dialog_visible.sync="dictionaryDialogVisible" :dictionary_type="1" :initList.sync="dictionaryWordsList" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import Pagination from "../../components/newUi/Pagination.vue";
import gxLoading from '../../mixins/gxLoading'
import DictionaryManage from './DictionaryManage.vue'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import NewAlienCheckPage from '../alienCheck/index.vue'

export default {
  name: 'NewCloudCheckPage',
  components: { DictionaryManage, MultiSelect, NewAlienCheckPage, GxLoading, PageSizeSelect, Pagination},
  mixins: [gxLoading],
  props: {
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tab: 0,
      kwLogSub: 0,
      kwJumpInput: 1,
      tuJumpInput: 1,
      tuTaskJumpInput: 1,
      ismanager: false,
      groupList: [],
      // 关键词检测
      kwList: [],
      kwPage: { limit: 10, page: 1, total: 0 },
      kwPageSizeOptions: [10, 20, 50, 100, 200, 1000, 2000],
      kwSearch: { word: '', lexicon_type: [] },
      kwSelected: [],
      kwAddShow: false,
      kwAddInfo: { lexicon_type: '', keywords: '' },
      kwAddLoading: false,
      kwCheckShow: false,
      kwCheckLoading: false,
      kwCheckInfo: { lexicon_type: [], channel: '1', detection_method: '2', group_id: [], child_group_id: [] },
      checkChildGroupList: [],
      dictionaryWordsList: [],
      imgDictionaryWordsList: [],
      dictionaryDialogVisible: false,
      channeList: { 1: { label: '云商品库' } },
      methodList: { 1: { label: '全量检测' }, 2: { label: '未检测数据' } },
      // 图片检测
      subTab: 'list',
      imgList: [],
      imgTaskList: [],
      imgPage: { limit: 50, page: 1, total: 0 },
      imgPageSizeOptions: [10, 20, 50, 100, 200, 1000, 2000],
      imgSearch: { image_check_status: '', group_id: '', child_group_id: '', sku_status: '', appraisal_status: '', ai_image_check_status: '' },
      imgTaskSearch: { status: '' },
      imgChildGroupList: [],
      checkedList: [],
      selList: [],
      checkStatus: { 1: { label: '未检测', type: 'error' }, 2: { label: '已检测', type: 'success' } },
      skuStatus: { 1: { label: '未替换', type: 'info' }, 2: { label: '已替换', type: 'success' }, 3: { label: '找不到', type: 'error' } },
      appraisalStatus: {
        1: { label: '未检测', value: 1 },
        2: { label: '待检测', value: 4 },
        3: { label: '有违规', value: 2 },
        4: { label: '无违规', value: 3 }
      },
      filterConfig: {},
      detailShow: false,
      detailInfo: {},
      imgDetailList: [],
      imgType: { 1: '主图', 2: '轮播图', 3: '详情图', 4: 'sku图' },
      batchShow: false,
      batchType: 'ai',
      batchInfo: { re_duplication: false, group_ids: [], child_group_id: [], detection_method: '' },
      batchChildGroupList: [],
      batchLoading: false,
      imgInclude: { include_main: 0, include_detail: 0, include_sku: 0 },
      checkWays: [{ label: '自选数据', value: 9 }, { label: '未检测数据', value: 2 }, { label: '全部检测', value: 1 }],
      powerNumTotal: 0,
      userInfo: {},
      userLoading: false,
      // 关键词检测记录
      logShow: false,
      logList: [],
      logPage: { limit: 10, page: 1, total: 0 },
      logPageSizeOptions: [10, 20, 50, 100, 200, 1000, 2000],
      logSearch: { status: '', group_id: '' },
      logStatusList: {},
      logChanneList: {},
      logMethodList: { 1: { label: '全量检测' }, 2: { label: '未检测数据' } },
      // 检测记录详情
      logDetailShow: false,
      logDetailInfo: {},
      logDetailList: [],
      logDetailPage: { limit: 10, page: 1, total: 0 },
      logDetailPageSizeOptions: [10, 20, 50, 100, 200, 1000, 2000],
      logDetailGroupIds: [],
      logDetailLexiconType: [],
      logDetailWord: '',
      logDetailStatus: [],
      logOperStatus: [],
      logSearchGroup: [],
      logDetailStatusList: {},
      logOperStatusList: {},
      logDetailSelected: [],
      logCountData: {},
      // 预览
      singleImgShow: false,
      singleImgUrl: '',

      alienType:9,//星人鉴图类型 9-AI检测  8-虚假检测
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    }),
    kwTotalPages() { return Math.max(1, Math.ceil(this.kwPage.total / this.kwPage.limit)) },
    kwPages() { return this.pageNums(this.kwPage.page, this.kwTotalPages) },
    imgTotalPages() { return Math.max(1, Math.ceil(this.imgPage.total / this.imgPage.limit)) },
    imgPages() { return this.pageNums(this.imgPage.page, this.imgTotalPages) },
    logTotalPages() { return Math.max(1, Math.ceil(this.logPage.total / this.logPage.limit)) },
    logPages() { return this.pageNums(this.logPage.page, this.logTotalPages) },
    logDetailTotalPages() { return Math.max(1, Math.ceil(this.logDetailPage.total / this.logDetailPage.limit)) },
    logDetailPages() { return this.pageNums(this.logDetailPage.page, this.logDetailTotalPages) },
    logDetailStatusOptions() {
      return Object.keys(this.logDetailStatusList).map(k => ({ id: k, name: this.logDetailStatusList[k] }))
    },
    logOperStatusOptions() {
      return Object.keys(this.logOperStatusList).map(k => ({ id: k, name: this.logOperStatusList[k] }))
    },
    kwAllChecked() {
      const selectable = this.kwList.filter(row => row.merchant_id !== 0 || this.ismanager)
      return selectable.length > 0 && selectable.every(row => this.kwSelected.includes(row.id))
    },
    imgAllChecked() {
      return this.imgList.length > 0 && this.imgList.every(row => this.checkedList.includes(row.item_id))
    },
    logDetailSelectedAll(){
      return this.logDetailSelected.length&&this.logDetailSelected.length===this.logDetailList.filter(row=>row.status==3&&row.oper_status==1).length
    },

  },
  watch: {
    activeTab(newVal) {
      if (typeof newVal === 'number' && newVal >= 0 && newVal <= 2) {
        this.switchMainTab(newVal)
      }
    }
  },
  created() {
    // 根据外部传入的 activeTab 切换到对应 tab
    if (typeof this.activeTab === 'number' && this.activeTab >= 0 && this.activeTab <= 2) {
      this.tab = this.activeTab
    }
    this.ismanager = (this.users && this.users.mer_user_id === '1')
    this.getGroupList()
    if (this.tab === 0) {
      this.initKwData()
    } else if (this.tab === 1) {
      this.getImgData()
    }
  },
  methods: {
    ...mapActions({
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
      getKeywordList: 'ucenter/getKeywordList',
      opKeywordAdd: 'ucenter/opKeywordAdd',
      opKeywordDelete: 'ucenter/opKeywordDelete',
      opSubmitDetection: 'ucenter/opSubmitDetection',
      getImgDetectionList: 'ucenter/getImgDetectionList',
      getImgDetectionTask: 'ucenter/getImgDetectionTask',
      getProductImagesList: 'ucenter/getProductImagesList',
      opSubmitBatchDetection: 'ucenter/opSubmitBatchDetection',
      opSubmitAiDetection: 'ucenter/opSubmitAiDetection',
      opStopImgDetection: 'ucenter/opStopImgDetection',
      opStartImgDetection: 'ucenter/opStartImgDetection',
      opPauseImgDetection: 'ucenter/opPauseImgDetection',
      getDetectionList: 'ucenter/getDetectionList',
      opStopDetection: 'ucenter/opStopDetection',
      getDetectionItemList: 'ucenter/getDetectionItemList',
      opDetectionBatchOperation: 'ucenter/opDetectionBatchOperation',
      getUserinfoData: 'login/getUserinfoData'
    }),
    pageNums(page, total) {
      const nums = []
      const start = Math.max(1, Math.min(page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    switchMainTab(i) {
      this.tab = i
      if (i === 0) {
        this.initKwData()
      } else if (i === 1) {
        this.getImgData()
      }
    },
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    formatGroupName(row) {
      let group_id = row.group_id || '-'
      let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
      let child_group_id = row.child_group_id || '-'
      const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
      const child_group_name = target ? target.name : null
      if (child_group_name) group_name += '|' + child_group_name
      return group_name
    },
    getGroupNameText(groupId, child_group_ids) {
      if (!groupId) return '全部'
      let ids = []
      if (typeof groupId === 'string') {
        try {
          ids = JSON.parse(groupId)
        } catch (e) {
          ids = groupId.split(',').map(item => item.trim())
        }
      } else {
        ids = Array.isArray(groupId) ? groupId : [groupId]
      }
      let childIds = []
      if (typeof child_group_ids === 'string') {
        try {
          childIds = JSON.parse(child_group_ids)
        } catch (e) {
          childIds = child_group_ids.split(',').map(item => item.trim())
        }
      } else {
        childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
      }
      return ids.filter(id => id)
          .map(id => this.groupList.find(item => item.id === id))
          .filter(Boolean)
          .map(item => {
            let name = item.name
            if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
              const matchedChildNames = item.child_groups
                  .filter(child => childIds.includes(child.id))
                  .map(child => child.name)
              if (matchedChildNames.length > 0) {
                name += '（' + matchedChildNames.join('、') + '）'
              }
            }
            return name
          })
          .join('、')
    },
    /**
     *  ── 关键词检测 ── */
    initKwData() {
      this.getDictionaryWords(1)
      this.refreshKw()
    },
    getDictionaryWords(type) {
      this.opGetDictionaryWords({
        data: { dictionary_type: type },
        success: (res) => {
          if (res.code === 200) {
            const list = res.data || []
            list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0))
            if (type === 2) {
              this.imgDictionaryWordsList = list
            } else {
              this.dictionaryWordsList = list
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    lexiconName(id) {
      const found = this.dictionaryWordsList.find(item => item.id === id)
      return found ? found.dictionary_name : '未知'
    },
    onKwPageSizeChange(size) {
      this.kwPage.limit = size
      this.kwPage.page = 1
      this.getKwList(1)
    },
    onImgPageSizeChange(size) {
      this.imgPage.limit = size
      this.imgPage.page = 1
      this.getImgList(1)
    },
    onImgPageSizeChangeTask(size) {
      this.imgPage.limit = size
      this.imgPage.page = 1
      this.getImgTaskList(1)
    },
    onLogPageSizeChange(size) {
      this.logPage.limit = size
      this.logPage.page = 1
      this.getLogList(1)
    },
    onLogDetailPageSizeChange(size) {
      this.logDetailPage.limit = size
      this.logDetailPage.page = 1
      this.getLogDetailList(1)
    },
    getKwList(page) {
      this.kwPage.page = page
      const params = { page_size: this.kwPage.limit, page: this.kwPage.page, ...this.kwSearch }
      if (params.word === '') delete params.word
      if (!params.lexicon_type || !params.lexicon_type.length) delete params.lexicon_type
      this.loadingStart()
      this.getKeywordList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.kwList = res.data.list || []
            this.kwPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleKwSearch() {
      this.kwPage.page = 1
      this.getKwList(1)
    },
    refreshKw() {
      this.kwPage.page = 1
      this.kwPage.total = 0
      this.kwSearch = { word: '', lexicon_type: [] }
      this.kwSelected = []
      this.getKwList(1)
    },
    toggleKwSel(row) {
      if (row.merchant_id === 0 && !this.ismanager) {
        this.$message.warning('系统关键词仅管理员可选')
        return
      }
      const idx = this.kwSelected.indexOf(row.id)
      if (idx > -1) this.kwSelected.splice(idx, 1)
      else this.kwSelected.push(row.id)
    },
    toggleKwAll() {
      const selectable = this.kwList.filter(row => row.merchant_id !== 0 || this.ismanager).map(row=>row.id)
      if (this.kwAllChecked) {
        this.kwSelected = this.kwSelected.filter(row => !selectable.includes(row))
      } else {
        const next = this.kwSelected.slice()
        selectable.forEach(row => {
          if (!next.includes(row)) next.push(row)
        })
        this.kwSelected = next
      }
    },
    kwBatchDelete() {
      if (!this.kwSelected.length) return
      this.$confirm(`是否确定删除${this.kwSelected.length}个关键词?`, '提示', { type: 'warning' }).then(() => {
        this.opKeywordDelete({
          data: { ids: this.kwSelected.join(',') },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.kwSelected = []
              this.getKwList(this.kwPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleKwAdd() {
      this.kwAddShow = true
      this.kwAddInfo = { lexicon_type: '', keywords: '' }
    },
    submitKwAdd() {
      if (!this.kwAddInfo.lexicon_type) {
        this.$message.warning('请选择检测词分类')
        return
      }
      const words = this.kwAddInfo.keywords.split(/\r\n|\r|\n|,|，/g).map(item => item.trim()).filter(item => item !== '')
      if (!words.length) {
        this.$message.warning('请填写关键词')
        return
      }
      this.kwAddLoading = true
      this.opKeywordAdd({
        data: { lexicon_type: this.kwAddInfo.lexicon_type, words: words.join(',') },
        success: (res) => {
          this.kwAddLoading = false
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.kwAddShow = false
            this.refreshKw()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleKwCheck() {
      this.kwCheckShow = true
      this.kwCheckInfo = { lexicon_type: [], channel: '1', detection_method: '2', group_id: [], child_group_id: [] }
      this.checkChildGroupList = []
    },
    switchKwLogSub(i) {
      this.kwLogSub = i
      if (i === 0) {
        this.initKwData()
      } else if (i === 1) {
        // 进入检测记录子 tab: 加载分组 + 检测记录列表
        if (!this.groupList.length) this.getGroupList()
        if (this.logSearch.status === '' && this.logSearch.group_id === '') {
          this.logSearch = { status: '', group_id: '' }
        }
        this.getLogList(this.logPage.page || 1)
      }
    },
    onKwJump() {
      const max = Math.max(1, Math.ceil(this.kwPage.total / this.kwPage.limit))
      const target = Math.min(Math.max(parseInt(this.kwJumpInput, 10) || 1, 1), max)
      this.kwJumpInput = target
      this.getKwList(target)
    },
    onTuJump() {
      const max = Math.max(1, Math.ceil(this.imgPage.total / this.imgPage.limit))
      const target = Math.min(Math.max(parseInt(this.tuJumpInput, 10) || 1, 1), max)
      this.tuJumpInput = target
      this.getImgList(target)
    },
    onTuTaskJump() {
      const max = Math.max(1, Math.ceil(this.imgPage.total / this.imgPage.limit))
      const target = Math.min(Math.max(parseInt(this.tuTaskJumpInput, 10) || 1, 1), max)
      this.tuTaskJumpInput = target
      this.getImgTaskList(target)
    },
    changeCheckGroupIds() {
      this.$set(this.kwCheckInfo, 'child_group_id', [])
      this.checkChildGroupList = this.groupList.filter(i => this.kwCheckInfo.group_id.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    submitKwCheck() {
      if (!this.kwCheckInfo.channel) {
        this.$message.warning('请选择商品渠道')
        return
      }
      if (!this.kwCheckInfo.detection_method) {
        this.$message.warning('请选择检测方式')
        return
      }
      this.kwCheckLoading = true
      this.opSubmitDetection({
        data: this.kwCheckInfo,
        success: (res) => {
          this.kwCheckLoading = false
          if (res.code === 200) {
            this.$message.success('检测提交成功')
            this.kwCheckShow = false
            this.switchKwLogSub(1)
          } else {
            this.$message.error(res.message)
          }
        },
        fail: () => {
          this.kwCheckLoading = false
        }
      })
    },
    handleDictionAdd() {
      this.dictionaryDialogVisible = true
      this.getDictionaryWords(1)
    },
    /**
     *  ── 图片检测 ── */
    getImgData() {
      this.getDictionaryWords(2)
      this.getUserInfo()
      this.refreshImg()
    },
    getUserInfo(isLoading) {
      this.userLoading = isLoading
      this.getUserinfoData({
        data: {},
        success: (res) => {
          this.userLoading = false
          if (res.code === 200) {
            this.userInfo = res.data
          }
        }
      })
    },
    switchSubTab(sub,type) {
      this.subTab = sub
      this.imgPage.page = 1
      this.imgPage.total = 0
      if (sub === 'list') {
        this.imgSearch = { image_check_status: '', group_id: '', child_group_id: '', sku_status: '', appraisal_status: '', ai_image_check_status: '' }
        this.getImgList(1)
      } else if(sub === 'task') {
        this.imgTaskSearch = { status: '' }
        this.getImgTaskList(1)
      }else {
        this.alienType = type
      }
    },
    getImgList(page) {
      this.imgPage.page = page
      const params = { page_size: this.imgPage.limit, page: this.imgPage.page, ...this.imgSearch }
      if (params.image_check_status === '') delete params.image_check_status
      if (params.ai_image_check_status === '') delete params.ai_image_check_status
      if (params.appraisal_status === '') delete params.appraisal_status
      if (params.group_id === '') delete params.group_id
      if (params.child_group_id === '') delete params.child_group_id
      if (params.sku_status === '') delete params.sku_status
      this.loadingStart()
      this.getImgDetectionList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.imgList = res.data.list || []
            this.imgPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    getImgTaskList(page) {
      this.imgPage.page = page
      const params = { page_size: this.imgPage.limit, page: this.imgPage.page, ...this.imgTaskSearch }
      if (params.status === '') delete params.status
      this.loadingStart()
      this.getImgDetectionTask({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.imgTaskList = res.data.list || []
            this.imgPage.total = res.data.total || 0
            this.filterConfig = { ...res.data }
            delete this.filterConfig.list
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleImgSearch() {
      this.imgPage.page = 1
      if (this.subTab === 'list') this.getImgList(1)
      else this.getImgTaskList(1)
    },
    handleImgGroupSearch() {
      this.changeImgGroupIds(this.imgSearch.group_id)
      this.handleImgSearch()
    },
    changeImgGroupIds(val) {
      this.$set(this.imgSearch, 'child_group_id', '')
      this.imgChildGroupList = this.groupList.filter(i => i.id == val).map(i => i.child_groups || []).flat()
    },
    changeBatchGroupIds(val) {
      this.$set(this.batchInfo, 'child_group_id', [])
      this.batchChildGroupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    refreshImg() {
      this.imgPage.page = 1
      this.imgPage.total = 0
      this.checkedList = []
      this.selList = []
      this.imgChildGroupList = []
      this.imgTaskSearch.status = ''
      this.handleImgSearch()
    },
    toggleImgSel(row) {
      const idx = this.checkedList.indexOf(row.item_id)
      if (idx > -1) {
        this.checkedList.splice(idx, 1)
        this.selList = this.selList.filter(i => i.item_id != row.item_id)
      } else {
        this.checkedList.push(row.item_id)
        this.selList.push(row)
      }
    },
    toggleImgAll() {
      const pageIds = this.imgList.map(i => i.item_id)
      if (this.imgAllChecked) {
        this.selList = this.selList.filter(i => !pageIds.includes(i.item_id))
      } else {
        const merged = this.selList.slice()
        this.imgList.forEach(row => {
          if (!merged.some(i => i.item_id === row.item_id)) merged.push(row)
        })
        this.selList = merged
      }
      this.checkedList = this.selList.map(i => i.item_id)
    },
    skuTagCls(s) {
      const map = { 1: 'gx-chk__tag--self', 2: 'gx-chk__tag--ok', 3: 'gx-chk__tag--info' }
      return map[s] || 'gx-chk__tag--self'
    },
    checkTagCls(s) {
      const map = { 1: 'gx-chk__tag--info', 2: 'gx-chk__tag--ok' }
      return map[s] || 'gx-chk__tag--fail'
    },
    imgTaskStatusStyle(status) {
      const map = {
        1: ['#FB923C', 'rgba(251,146,60,.1)', 'rgba(251,146,60,.3)'],
        2: ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
        3: ['#4ADE80', 'rgba(74,222,128,.1)', 'rgba(74,222,128,.3)'],
        8: ['#8B5CF6', 'rgba(139,92,246,.1)', 'rgba(139,92,246,.3)']
      }
      const [color, bg, border] = map[status] || ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    handleDetail(row) {
      this.detailInfo = { ...row }
      this.detailShow = true
      this.imgDetailList = []
      this.getProductImagesList({
        data: { item_id: row.item_id },
        success: (res) => {
          if (res.code === 200) {
            // this.imgDetailList = res.data || []
            const imgObj={}
            this.imgDetailList=[]
            if(res.data.length){
              res.data.forEach(item=>{
                if(!imgObj[item.image_type]){
                  imgObj[item.image_type]={
                    label:this.imgType[item.image_type],
                    imgs:[]
                  }
                }
                imgObj[item.image_type].imgs.push(item.origin_url)
              })
              this.imgDetailList = Object.keys(imgObj).map(i=>imgObj[i])
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleBatch(type) {
      this.batchType = type
      this.batchShow = true
      this.batchInfo = {
        re_duplication: false,
        group_ids: [],
        child_group_id: [],
        detection_method: this.checkedList.length ? 9 : ''
      }
      this.imgInclude = { include_main: 0, include_detail: 0, include_sku: 0 }
      this.batchChildGroupList = []
      this.powerNumTotal = 0
    },
    submitBatchCheck() {
      const keys = ['include_main', 'include_detail', 'include_sku']
      const hasInclude = keys.some(k => this.imgInclude[k] == 1)
      if (!hasInclude) {
        this.$message.warning('请选择检测范围')
        return
      }
      if (!this.batchInfo.detection_method) {
        this.$message.warning('请选择检测方式')
        return
      }
      if (this.batchInfo.detection_method === 9 && !this.checkedList.length) {
        this.$message.warning('请选择要检测的数据')
        return
      }
      const params = { ...this.batchInfo, ...this.imgInclude }
      if (this.batchInfo.detection_method === 9) {
        params.ids = this.checkedList.join(',')
      }
      this.batchLoading = true
      const done = (res) => {
        this.batchLoading = false
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.batchShow = false
          this.checkedList = []
          this.selList = []
          this.refreshImg()
        } else {
          this.$message.error(res.message)
        }
      }
      if (this.batchType === 'ai' || this.batchType === 'false') {
        params.detection_type = this.batchType === 'ai' ? 9 : 8
        this.opSubmitAiDetection({ data: params, success: done })
      } else {
        params.word_depots = []
        this.opSubmitBatchDetection({ data: params, success: done })
      }
    },
    handleStopTask(row) {
      this.$confirm(`确定要终止【${row.task_no}】的图片检测吗？`, '提示', { type: 'warning' }).then(() => {
        this.opStopImgDetection({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('终止成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleStartTask(row) {
      this.$confirm(`确定要启动【${row.task_no}】的图片检测吗？`, '提示', { type: 'warning' }).then(() => {
        this.opStartImgDetection({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('启动成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handlePauseTask(row) {
      this.$confirm(`确定要暂停【${row.task_no}】的图片检测吗？`, '提示', { type: 'warning' }).then(() => {
        this.opPauseImgDetection({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('暂停成功')
              this.getImgTaskList(this.imgPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    toRecharge() {
      window.open('/uc_wallet?menuId=116')
    },
    /**
     *  ── 关键词检测记录 ── */
    openLog() {
      this.logShow = true
      this.logPage.page = 1
      this.logPage.total = 0
      this.logSearch = { status: '', group_id: '' }
      this.getLogList(1)
    },
    getLogList(page) {
      this.logPage.page = page
      const params = { page_size: this.logPage.limit, page: this.logPage.page, ...this.logSearch }
      if (params.status === '') delete params.status
      if (params.group_id === '') delete params.group_id
      this.loadingStart()
      this.getDetectionList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.logList = res.data.list || []
            this.logPage.total = res.data.total || 0
            this.logChanneList = res.data.channel_filter || {}
            this.logStatusList = {}
            const type = ['danger', 'info', 'primary', 'success']
            ;(res.data.status_filter || []).forEach((item, index) => {
              this.logStatusList[index] = { label: item, value: index, type: type[index] || 'info' }
            })
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleLogSearch() {
      this.logPage.page = 1
      this.getLogList(1)
    },
    handleLogRefresh() {
      this.logSearch = { status: '', group_id: '' }
      this.handleLogSearch()
    },
    getLexiconTypeText(lexiconType) {
      if (!lexiconType) return '全部'
      let ids = []
      if (typeof lexiconType === 'string') {
        try {
          ids = JSON.parse(lexiconType)
        } catch (e) {
          ids = lexiconType.split(',').map(item => item.trim())
        }
      } else {
        ids = Array.isArray(lexiconType) ? lexiconType : [lexiconType]
      }
      return ids.map(id => {
        const item = this.dictionaryWordsList.find(obj => obj.id == id)
        return item ? item.dictionary_name : ''
      }).filter(Boolean).join('、')
    },

    logStatusStyle(status) {
      const map = {
        0: ['#C8443C', '#FFF1F0', '#FFCCC7'],
        1: ['#FB923C', 'rgba(251,146,60,.1)', 'rgba(251,146,60,.3)'],
        2: ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
        3: ['rgb(82, 196, 26)', 'rgb(246, 255, 237)', 'rgb(183, 235, 143)']
      }
      const [color, bg, border] = map[status] || ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    handleStopLog(row) {
      this.$confirm('确定要终止检测吗？', '提示', { type: 'warning' }).then(() => {
        this.opStopDetection({
          data: { id: row.id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('终止成功')
            } else {
              this.$message.error(res.message)
            }
            this.getLogList(this.logPage.page)
          }
        })
      }).catch(() => {})
    },
    /**
     *  ── 检测记录详情 ── */
    openLogDetail(row) {
      if (!row.group_id || (Array.isArray(row.group_id) && row.group_id.length === 0)) {
        this.logSearchGroup = this.groupList
      } else {
        const ids = Array.isArray(row.group_id) ? row.group_id : String(row.group_id).split(',')
        this.logSearchGroup = this.groupList.filter(item => ids.includes(item.id)||ids.includes(String(item.id)))
      }
      this.logDetailGroupIds = []
      this.logDetailStatus = []
      this.logDetailLexiconType = []
      this.logDetailWord = ''
      this.logOperStatus = []
      this.logDetailInfo = { id: row.id, task_no: row.task_no }
      this.logDetailShow = true
      this.logDetailList = []
      this.logDetailPage = { limit: 10, page: 1, total: 0 }
      this.logDetailSelected = []
      this.getLogDetailList(1)
    },
    getLogDetailList(page) {
      this.logDetailSelected=[]
      this.logDetailPage.page = page
      const params = {
        id: this.logDetailInfo.id,
        page_size: this.logDetailPage.limit,
        page: this.logDetailPage.page,
        status: this.logDetailStatus,
        keyword: this.logDetailWord,
        groupIds: this.logDetailGroupIds,
        lexicon_types: this.logDetailLexiconType,
        oper_status: this.logOperStatus
      }
      if (!params.keyword) delete params.keyword
      this.getDetectionItemList({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.logDetailList = res.data.list || []
            this.logDetailPage.total = res.data.total || 0
            this.logOperStatusList = res.data.oper_status_filter || {}
            this.logDetailStatusList = res.data.status_filter || {}
            this.logCountData = {
              untreated_count: res.data.untreated_count || 0,
              normal_count: res.data.normal_count || 0,
              abnormal_count: res.data.abnormal_count || 0
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleLogDetailSearch() {
      this.logDetailPage.page = 1
      this.getLogDetailList(1)
    },
    handleLogDetailRefresh() {
      this.logDetailStatus = []
      this.logDetailWord = ''
      this.logDetailGroupIds = []
      this.logDetailLexiconType = []
      this.logOperStatus = []
      this.handleLogDetailSearch()
    },
    toggleLogDetailSelAll(){
      if(this.logDetailSelectedAll) this.logDetailSelected=[]
      else this.logDetailSelected = this.logDetailList.filter(row=>row.status == 3 && row.oper_status == 1)
    },
    toggleLogDetailSel(row) {
      if (!(row.status == 3 && row.oper_status == 1)) {
        this.$message.warning('仅异常未处理数据可操作')
        return
      }
      const idx = this.logDetailSelected.indexOf(row)
      if (idx > -1) this.logDetailSelected.splice(idx, 1)
      else this.logDetailSelected.push(row)
    },
    handleLogBatch(type) {
      const typeText = ['', '', '过滤', '下架', '正常']
      this.$confirm(`确定要批量${typeText[type]}吗？`, '提示', { type: 'warning' }).then(() => {
        this.opDetectionBatchOperation({
          data: {
            ids: this.logDetailSelected.map(item => item.id).join(','),
            oper_type: type
          },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(`${type == 2 ? '过滤' : '下架'}成功`)
              this.logDetailSelected = []
              this.getLogDetailList(this.logDetailPage.page)
            }
          }
        })
      }).catch(() => {})
    },
    logFormatGroupName(row) {
      let group_id = (row.productimport && row.productimport.group_id) || '-'
      let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
      let child_group_id = (row.productimport && row.productimport.child_group_id) || '-'
      const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
      const child_group_name = target ? target.name : null
      if (child_group_name) group_name += '|' + child_group_name
      return group_name
    },
    logDetailStatusText(status) {
      return this.logDetailStatusList[status] || ''
    },
    logDetailStatusCls(status) {
      const map = { 1: 'gx-chk__tag--info', 2: 'gx-chk__tag--ok', 3: 'gx-chk__tag--fail' }
      return map[status] || 'gx-chk__tag--info'
    },
    /**
     *  ── 预览 ── */
    previewSingle(url) {
      if (!url) return
      this.singleImgUrl = url
      this.singleImgShow = true
    }
  }
}
</script>

<style scoped>
.w140{
  width: 140px;
}
.search-wrap :deep(.el-form--label-top .el-form-item__label){
  font-size: 10px;
  line-height: 15px;
  color: #999999;
  margin-bottom: 4px;
}
/* ===== Element UI 风格 ===== */
.gx-chk {
 display: flex;
  flex-direction: column;
  color: #303133;
  font-size: 14px;
}
.gx-chk__tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
  margin-bottom: 16px;
}
.gx-chk__tab {
  padding: 9px 22px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  background: rgb(255, 255, 255);
  color: rgb(102, 102, 102);
  font-weight: 400;
  transition: 0.15s;
  white-space: nowrap;
}
.gx-chk__tab--on {
  color: var(--gx-red);
  border-bottom: 2px solid var(--gx-red);
}
.gx-chk__tab--on-gold {
  color: var(--gx-gold);
  border-bottom: 2px solid var(--gx-gold);
}

.gx-chk__tab.no-bg{
  background: transparent;
}
.gx-chk__tab-beam {
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  background: #409eff;
  border-radius: 2px 2px 0 0;
}
.gx-chk__seg {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}
.gx-chk__seg-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background: #ffffff;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  transition: all .2s;
}
.gx-chk__seg-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.gx-chk__seg-btn--on {
  background: #ffffff;
  border-color: #409eff;
  color: #409eff;
  font-weight: 500;
}

/* ===== 按钮 ===== */
.gx-chk__btn {
  height: 30px;
  padding: 0px 16px;
  border-radius: 4px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  font-weight: 500;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .2s;
  white-space: nowrap;
}
.gx-chk__btn:hover {
  background-color: rgb(245,240,232);
}
.gx-chk__btn--sm{
  height: 24px;
  padding: 0px 8px;
}
.gx-chk__btn--lg{
  height: 32px;
  padding: 0 13px;
  border-radius: 6px;
  font-size: 13px;
}

.gx-chk__btn--orange-all{
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
  border: none;
  color: rgb(244, 246, 248);
  font-weight: 600;
}
.gx-chk__btn--blue {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: rgb(22, 119, 255);
}
.gx-chk__btn--blue:hover {
  background: rgb(22,119,255);
  color: #fff;
}
.gx-chk__btn--warn {
  background: #ffffff;
  border-color: #faecd8;
  color: #e6a23c;
}
.gx-chk__btn--warn:hover {
  background: #fdf6ec;
  color: #e6a23c;
  border-color: #faecd8;
}
.gx-chk__btn--danger {
  background: #ffffff;
  border-color: #fbc4c4;
  color: #f56c6c;
}
.gx-chk__btn--danger:hover {
  background: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}
.gx-chk__btn--danger:disabled,
.gx-chk__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-chk__btn--danger:disabled:hover {
  background: #ffffff;
  color: #f56c6c;
}

/* ===== 筛选条 ===== */
.gx-chk__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 3px;
}
.gx-chk__fitem {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-chk__flabel {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}
.gx-chk__fitem--btns {
  /* margin-left: auto; */
}
.gx-chk__fitem--right {
  margin-left: auto;
}
.gx-chk__input {
  width: 200px;
  height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  font-size: 13px;
  color: #303133;
  outline: none;
  box-sizing: border-box;
  transition: border-color .2s;
}
.gx-chk__input:focus {
  border-color: #409eff;
}
.gx-chk__select {
  height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background: #ffffff;
  font-size: 13px;
  color: #303133;
  outline: none;
  min-width: 160px;
  transition: border-color .2s;
}
.gx-chk__select:focus {
  border-color: #409eff;
}
.gx-chk__select--full {
  width: 100%;
  min-width: 0;
}

/* ===== 操作行 ===== */
.gx-chk__actionrow {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 12px;
  background: #ffffff;
  border-top: none;
  border-bottom: none;
  border-radius: 0;
  flex-wrap: wrap;
}
.gx-chk__selected {
  font-size: 13px;
  color: #606266;
  margin-right: auto;
}

/* ===== 表格 ===== */
.gx-chk__table {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 3px;
}
.gx-chk__table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.gx-chk__table thead {
/*  position: sticky;*/
  top: 0;
  z-index: 1;
}
.gx-chk__table th {
  padding: 9px 12px;
  text-align: left;
  background: rgb(245, 240, 232);
  color: #666666;
  font-size: 11px;
  font-weight: 500;
  border-bottom: 1px solid #ebeef5;
  white-space: nowrap;
}
.gx-chk__table td {
  padding: 10px 12px;
  font-size: 13px;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  vertical-align: middle;
}
.gx-chk__table tbody tr {
  transition: background-color .2s;
}
.gx-chk__table tbody tr:hover > td,
.gx-chk__table tbody tr:hover {
  background: #fef0f0 !important;
}

/* ===== 复选框（Element UI 风格） ===== */
.gx-chk__check {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: all .2s;
  vertical-align: middle;
}

.gx-chk__check:hover {
  border-color: linear-gradient(135deg, #D4A946, #E8C778);
}
.gx-chk__check--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
}

.gx-chk__check--disabled{
  cursor: not-allowed;
  background: #f5f5f5;
}

/* ===== 文字工具类 ===== */
.gx-chk__mono {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 13px;
}
.gx-chk__dim {
  color: rgb(153, 153, 153)!important;
}
.gx-chk__gold {
  color: #e6a23c;
  font-weight: 600;
}
.gx-chk__req {
  color: #f56c6c;
  font-style: normal;
  margin-right: 4px;
}

/* ===== 状态徽标 ===== */
.gx-chk__status {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  color: #409eff;
  white-space: nowrap;
}
.gx-chk__status-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.gx-chk__err {
  font-size: 12px;
  color: #f56c6c;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-chk__power {
  font-size: 12px;
  color: #e6a23c;
  margin-top: 3px;
}

/* ===== 标签 ===== */
.gx-chk__tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  white-space: nowrap;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  color: #409eff;
  font-weight: 500;
}
.gx-chk__tag--sys {
  background: #ecf5ff;
  border-color: var(--gx-cyan);
  color: var(--gx-cyan);
}
.gx-chk__tag--self {
  background: rgb(255, 247, 230);
  border-color:rgb(255, 213, 145);
  color:#fb923c;
}
.gx-chk__tag--ok {
  background: #f0f9eb;
  border-color: #c2e7b0;
  color: #67c23a;
}
.gx-chk__tag--fail {
  background: #fef0f0;
  border-color: #fbc4c4;
  color: #f56c6c;
}
.gx-chk__tag--info {
  background: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}

/* ===== 商品缩略图 ===== */
.gx-chk__goods {
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 240px;
}
.gx-chk__thumb {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
}
.gx-chk__thumb--nobor{
  border: none;
}
.gx-chk__thumb--lg {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
}
.gx-chk__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-chk__goods-body {
  min-width: 0;
}
.gx-chk__goods-title {
  font-size: 13px;
  color: #303133;
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 280px;
}
.gx-chk__group {
  font-size: 13px;
  color: #303133;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.gx-chk__counts {
  font-size: 12px;
  line-height: 1.7;
  white-space: nowrap;
  color: #606266;
}
.gx-chk__counts--stat {
  margin-left: auto;
  color: #f56c6c;
}
.gx-chk__txt {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ===== 行内操作按钮 ===== */
.gx-chk__ops {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-width: 200px;
}
.gx-chk__op {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  border: none;
  background: transparent;
  color: #409eff;
  white-space: nowrap;
  transition: all .2s;
}
.gx-chk__op:hover {
  color: #66b1ff;
}
.gx-chk__op:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-chk__op--edit {
  color: #409eff;
}
.gx-chk__op--danger {
  color: #f56c6c;
}
.gx-chk__op--danger:hover {
  color: #f78989;
}
.gx-chk__op--recover {
  color: #67c23a;
}
.gx-chk__op--recover:hover {
  color: #85ce61;
}

/* ===== 空态 ===== */
.gx-chk__empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #909399;
  font-size: 13px;
}

/* ===== 分页 ===== */
.gx-chk__pager {
  padding:10px 14px;
  background: rgb(245, 240, 232);
  flex-wrap: wrap;
  gap: 10px;
}
.gx-chk__pager-total {
  font-size: 13px;
  color: #606266;
}

/* ===== 弹窗 ===== */
.gx-chk__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-chk__modal--wide {
  z-index: 720;
}
.gx-chk__modal-box {
  width: 100%;
  max-width: 600px;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-chk__modal-box--lg {
  max-width: 680px;
}
.gx-chk__modal-box--xl {
  max-width: 1200px;
}
.gx-chk__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
  background: rgb(245, 240, 232);
}
.gx-chk__modal-head_left{
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-chk__modal-head_line {
  width: 3px;
  height: 15px;
  background: #f56c6c;
  border-radius: 4px;
}
.gx-chk__modal-title {
  font-size: 15px;
  font-weight: 600;
  color: rgb(26, 26, 46);
}
.gx-chk__modal-title_left{
  display: flex;
  gap: 8;
  align-items: center;
}
.gx-chk__modal-title_line{
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-chk__modal-body {
  padding: 20px;
  overflow-y: auto;
}
.gx-chk__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
}

.gx-chk__label {
  display: block;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}
.gx-chk__textarea {
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  font-size: 13px;
  color: #303133;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  transition: border-color .2s;
}
.gx-chk__textarea:focus {
  border-color: #409eff;
}
.gx-chk__radio-group {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}
.gx-chk__modal-field{
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
  padding: 9px 12px;
  background: rgb(245, 240, 232);
  border-radius: 6px;
  border: 2px solid rgb(224, 224, 236);
}

/* 基础按钮样式 */
.gx-chk__radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border: 1px solid #dcdcdc !important; /* 基础灰色边框 */
  border-radius: 8px !important;
  cursor: pointer;
  box-sizing: border-box !important;
  background: #fff !important;
  color: #333 !important;
}

/* 选中状态：外层方框变红 + 浅红背景 */
.gx-chk__radio-item.checked {
  border: 1px solid #dd2222 !important; /* 红色边框 */
  background-color: #fff2f2 !important; /* 浅红背景 */
  color: #dd2222 !important; /* 文字变红（可选） */
}

/* Radio小圆点样式（红框+白心） */
.gx-chk__radio-item input[type="radio"] {
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  border: 2px solid #ccc !important;
  border-radius: 50% !important;
  background: #fff !important;
  outline: none !important;
  position: relative !important;
}

/* Radio选中样式 */
.gx-chk__radio-item input[type="radio"]:checked {
  border-color: #dd2222 !important;
  background: #dd2222 !important;
}
.gx-chk__radio-item input[type="radio"]:checked::after {
  content: "" !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 6px !important;
  height: 6px !important;
  border-radius: 50% !important;
  background: #fff !important;
}

.gx-chk__power-box {
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 4px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-chk__power-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #303133;
  flex-wrap: wrap;
}
.gx-chk__detail-head {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgb(245, 240, 232);
  border: 2px solid rgb(224, 224, 236);
  margin-bottom: 14px;
}
.gx-chk__detail-goods-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 3px;
}
.gx-chk__detail-list {
  max-height: 52vh;
  overflow-y: auto;
}
.gx-chk__detail-title{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 8px;
  /*position: relative;
  padding-left: 9px;*/
}
.gx-chk__detail-bar{
  display: inline-block;
  width: 3px;
  height: 12px;
  border-radius: 1px;
  background: rgb(200, 68, 60);
  margin-right: 6px;
  vertical-align: middle;
}
.gx-chk__detail-title:before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
}
.gx-chk__detail-imgs{
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-chk__detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px dashed #ebeef5;
  font-size: 13px;
}
.gx-chk__single-img {
  width: 100%;
  border-radius: 4px;
}


/* ===== 图1 调整：子 tab 红色下划线 + 检测记录子块视觉 ===== */

/* 检测记录子块:行高更舒展、字号略大 */
.gx-chk__log {

/*  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 8px 0 12px;*/
}


/* 状态徽标(图1 浅色填充) */
/*.gx-chk__log .gx-chk__status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 10px;
  background: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fbc4c4;
  font-weight: 500;
}*/


/* 子块右侧取消/确定按钮组 */
.gx-chk__log__ops {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 6px 16px 0;
}
.gx-chk__log__cancel {
  height: 24px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color: rgb(200, 68, 60);
  font-size: 11px;
  cursor: pointer;
}
.gx-chk__log__cancel:hover {
  color: #fff;
  background-color: rgb(200, 68, 60);
}
.gx-chk__log__confirm {
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #f56c6c;
  background: #f56c6c;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
}
.gx-chk__log__confirm:hover {
  background: #e55a5a;
  border-color: #e55a5a;
}
.gx-chk__kw{}

/* 分页三列 */
.gx-chk__pager--kw {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}
.gx-chk__pager-col {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #606266;
}
.gx-chk__pager-col--left { justify-content: flex-start; }
.gx-chk__pager-col--center { justify-content: center; }
.gx-chk__pager-col--right { justify-content: flex-end; }
.gx-chk__pager-total { font-size: 13px; color: #606266; }
.gx-chk__pager-jump { display: inline-flex; align-items: center; gap: 4px; color: #606266; }
.gx-chk__pager-input {
  width: 36px;
  height: 24px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 6px;
  font-size: 13px;
  outline: none;
  color: #303133;
  text-align: center;
}
.gx-chk__pager-input:focus { border-color: #f56c6c; }
.gx-chk__pager-size { width: 110px; }
.gx-chk__pager-size .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}


/* ===== 新增关键词弹窗 ===== */
.gx-chk__modal-box--add {
  max-width: 560px;
  border-radius: 10px;
  border: 2px solid rgb(224, 224, 236);
}

.gx-chk__modal-close {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #909399;
  transition: all .2s;
}
.gx-chk__modal-close:hover {
  border-color: #f56c6c;
  color: #f56c6c;
  background: #fef0f0;
}
.gx-chk__modal-box--add .gx-chk__modal-body {
  padding: 0 20px 20px;
}
.gx-chk__modal-box--add .gx-chk__btn--blue {
  background: linear-gradient(135deg, #f56c6c, #f8797a);
  border-color: #f56c6c;
  color: #ffffff;
  font-weight: 500;
}
.gx-chk__modal-box--add .gx-chk__btn--blue:hover {
  background: linear-gradient(135deg, #e55a5a, #f56c6c);
  border-color: #e55a5a;
}
/* 弹窗 body */
.gx-chk__add-kw { display: flex; flex-direction: column; gap: 16px; }
.gx-chk__add-kw__row {
  margin-top: 20px;
 }
.gx-chk__add-kw__kw { display: flex; gap: 14px; align-items: flex-start; }
.gx-chk__add-kw__kw .gx-chk__field { flex: 1; margin-bottom: 0; }
.gx-chk__add-kw__kw .gx-chk__textarea {
  border-color: #e4e7ed;
  border-radius: 4px;
  padding: 10px 12px;
  line-height: 1.8;
  min-height: 160px;
  font-size: 13px;
  color: #303133;
  resize: vertical;
}
.gx-chk__add-kw__kw .gx-chk__textarea:focus { border-color: #f56c6c; }
/* 填写提示 */
.gx-chk__add-kw__hint {
  width: 148px;
  flex-shrink: 0;
  background: #fef9f5;
  border: 1px solid #faecd8;
  border-radius: 4px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 26px;
}
.gx-chk__add-kw__hint-icon { margin-bottom: 4px; }
.gx-chk__add-kw__hint-text {
  font-size: 12px;
  color: #e6a23c;
  line-height: 1.6;
  margin: 0;
}

/* ══ 图片检测-检测列表：上标签下输入框布局 ══ */
.gx-chk__filter--white {
  padding: 14px 16px;
  background: #FFFFFF;
  border: 1px solid #ECEEF2;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.gx-chk__filter--white .gx-chk__frow {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
}
.gx-chk__filter--white .gx-chk__frow--bottom {
  align-items: center;
  justify-content: space-between;
}
.gx-chk__filter--white .gx-chk__fitem--col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}
.gx-chk__filter--white .gx-chk__flabel {
  font-size: 12px;
  color: #6A6A8A;
  white-space: nowrap;
}
.gx-chk__filter--white .gx-chk__select {
  height: 30px;
  min-width: 120px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  padding: 0 10px;
  background: #FFFFFF;
  box-sizing: border-box;
}
.gx-chk__filter--white .gx-chk__btns {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}
.gx-chk__filter--white .gx-chk__btn {
  height: 30px;
  font-size: 12px;
  border-radius: 6px;
  padding: 0 16px;
}
.gx-chk__filter--white .gx-chk__btn:not(.gx-chk__btn--danger) {
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
  color: #FFFFFF;
  filter: brightness(1);
}
.gx-chk__filter--white .gx-chk__btn:not(.gx-chk__btn--danger):hover {
    filter: brightness(1.08);
}
.gx-chk__filter--white .gx-chk__btn--danger {
  background: #FFFFFF;
  border-color: #DCDFE6;
  color: #606266;
}
.gx-chk__filter--white .gx-chk__btn--danger:hover {
  background: #F5F7FA;
  border-color: #C0C4CC;
  color: #606266;
}
.gx-chk__filter--white .gx-chk__selected {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-chk__filter--white .gx-chk__gold {
  color: #C8443C;
  font-weight: 600;
}
</style>
